<template>
    <div class="container p-0">

     

        <!-- {{storeSelected}} -->
        <!-- Top Filter -->
         <div class="row align-items-baseline mt-5 mb-5">
             
            <div class="col-12 text-center col-lg-6 text-lg-right">
            <p class="h4">Filter</p>
            </div>

            <div class="col-12 text-center col-lg-6 text-lg-right pr-lg-0" >
                
                <div ref = "showStarDropDown" @click = "showStarDropDown=!showStarDropDown" class="blockbtn p-3 position-relative">
                    
                    <img class="" style="float:left; position:relative; top:2px; left:220px; pointer-events:none; width:18px; height:14px; " src="builds/l_down_arrow.svg" alt="drop arrow">
                    <p class="p-1 m-0 pr-5">{{filterActive}}</p>

                    <div :class = "{displayNot:showStarDropDown}" class="dropdownfilter">
                        <a @click.stop.prevent = "starFilterSelected('Most Recent')" class="d-block pb-4 mt-4 color2 font-weight-bold" href="#">Most Recent</a>
                        <a @click.stop.prevent = "starFilterSelected('5 Stars')" class="d-block pb-4 color2" href="#">5 Stars Only</a>
                        <a @click.stop.prevent = "starFilterSelected('4 Stars')" class="d-block pb-4 color2" href="#">4 Stars Only</a>
                        <a @click.stop.prevent = "starFilterSelected('3 Stars')" class="d-block pb-4 color2" href="#">3 Stars Only</a>
                        <a @click.stop.prevent = "starFilterSelected('2 Stars')" class="d-block pb-4 color2" href="#">2 Stars Only</a>
                        <a @click.stop.prevent = "starFilterSelected('1 Star')" class="d-block pb-4 color2" href="#">1 Star Only</a>
                    </div>

                </div>



            </div>

        </div>


        <bounce-loader v-if= "showloader" :color="loader.color" :size="loader.size"></bounce-loader>    



        <!-- Result Cells -->
   
            <transition v-on:before-enter = "beforeEnterELMainData" v-on:enter = "enterELMainData" v-bind:class = "false">
                        
            <div v-if = "showResultMainContent">

                    <div class="row resultContent">

                            <!-- No data available in this store for the active filter -->
                            <div v-if = "dataFilteredForDisplay.length < 1" class="col-12 mt-5 text-center">
                                <div class="mx-auto" style = "background-color:#f68e95; border-radius:12px; color:white; max-width:450px;">
                                    <span class="small m-0 px-md-5 px-3 py-2" >There are no <span class="font-weight-bold">{{filterActive}}</span> reviews for <span class="font-weight-bold">{{storeSelected.name}}</span>.</span>
                                </div>
                                <hr class="hrcolor1">
                            </div>
                                
                                    <!-- Each Cell -->
                                    <div class="jumbotron" v-for = "n in pageDataDisplay.e">
                                        <!-- {{n-1}} -->
                                        <!-- {{pageDataDisplay}} dataFilteredForDisplay {{dataFilteredForDisplay.length}} supplementDataForDisplay {{supplementDataForDisplay.length}} totalResultDisplayed {{totalResultDisplayed}} -->
                                        <div :class = "each = dataFilteredForDisplay[n-1]"></div>
                                        <div class="d-flex align-items-start">

                                            <div class="" style="flex:1 1 0;">
                                                <div class="d-flex flex-column align-items-center displayinitials justify-content-center "><p class="p-0 m-0 h2 text-center ">{{each.first_name.charAt(0)}}{{each.last_name.charAt(0)}}</p></div>
                                            </div>

                                            <div class="ml-3 mr-3 ml-lg-5 mt-2 " style="flex:8 1 0;">
                                                
                                                <span class="percentagebaroutline" :style = "getColor(each.actual_pct,'border')"><span class="percentagebarfill" :style = "getColor(each.actual_pct,'bg')"></span></span>
                                                <p class="subtitle small mt-3">By {{each.first_name}} {{each.last_name}} on {{convertDate(each.date)}} - {{each.city}}, {{each.state}}</p>
                                                <p class="comments mt-5 text-center text-sm-left mb-5">“{{each.comments}}”</p>
                                            

                                                <div class="dividedRank1 clearfix text-center text-sm-left">
                                                    <span class="ratingtitle">
                                                        <p class="small mt-1">{{each.ratings[0].name}}</p>
                                                    </span>

                                                    <span class = "d-inline-block ml-sm-3" >
                                                        <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                            <div v-if = "each.ratings[0].actual_score >= 1"  class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[0].actual_score >= 2"  class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[0].actual_score >= 3" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[0].actual_score >= 4" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[0].actual_score >= 5" class="reviewiconfilldark"></div>
                                                        </div>
                                                    </span>
                                                </div>

                                                <div class="dividedRank2 clearfix text-center text-sm-left">
                                                    <span class="ratingtitle">
                                                        <p class="small mt-1">{{each.ratings[1].name}}</p>
                                                    </span>

                                                    <span class = "d-inline-block ml-sm-3" >
                                                        <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                            <div v-if = "each.ratings[1].actual_score >= 1" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[1].actual_score >= 2" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[1].actual_score >= 3" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[1].actual_score >= 4" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[1].actual_score >= 5" class="reviewiconfilldark"></div>
                                                        </div>
                                                    </span>
                                                </div>

                                                <div class="dividedRank3 clearfix text-center text-sm-left">
                                                    <span class="ratingtitle">
                                                        <p class="small mt-1">{{each.ratings[2].name}}</p>
                                                    </span>

                                                    <span class = "d-inline-block ml-sm-3" >
                                                        <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                            <div v-if = "each.ratings[2].actual_score >= 1" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[2].actual_score >= 2" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[2].actual_score >= 3" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[2].actual_score >= 4" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[2].actual_score >= 5" class="reviewiconfilldark"></div>
                                                        </div>
                                                    </span>
                                                </div>
                                                                    
                                                <div class="dividedRank4 clearfix text-center text-sm-left">
                                                    <span class="ratingtitle">
                                                        <p class="small mt-1">{{each.ratings[3].name}}</p>
                                                    </span>

                                                    <span class = "d-inline-block ml-sm-3" >
                                                        <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                            <div v-if = "each.ratings[3].actual_score >= 1" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[3].actual_score >= 2" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[3].actual_score >= 3" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[3].actual_score >= 4" class="reviewiconfilldark"></div>
                                                        </div>
                                                        <div class="reviewiconborderdark mr-1">
                                                            <div v-if = "each.ratings[3].actual_score >= 5" class="reviewiconfilldark"></div>
                                                        </div>
                                                    </span>
                                                </div>



                                            </div>
                                            
                                            <div class="perText" style="flex:0 0 0;">{{Math.floor(each.actual_pct*100)}}%</div>
                                            
                                        </div>

                        

                                    </div>
                                    <!-- End of Each Cell -->
            
                            <!-- No Data for a supplement display -->
                            <div v-if = "supplementDataForDisplay.length < 1 && dataFilteredForDisplay.length <= 3" class="col-12 text-center mt-5">
                                <div class="mx-auto" style = "background-color:#f68e95; border-radius:12px; color:white; max-width:450px;">
                                    <span class="small m-0 px-md-5 px-3 py-2" >There are no <span class="font-weight-bold">{{filterActive}}</span> reviews for other markets.</span>
                                </div>
                                <hr class="hrcolor1">
                            </div> 

                                <!-- Supplement display heading -->
                                <div v-if = "supplementDataForDisplay.length >= 1" class="col-12 text-center ">
                                    <div class="mx-auto" style = "background-color:#cfd1d4; border-radius:12px; max-width:450px;">
                                        <span class="small px-md-5 px-3 py-2">Here are some <span class="font-weight-bold">{{filterActive}}</span> reviews from other markets.</span>
                                    </div>
                                        <hr class="hrcolor1">
                                </div>

                           

                                   
                                <!-- Each Cell SupplementView -->
                                <div class="jumbotron" v-for = "(each, eachIndex) in supplementDataForDisplay">
                                    
                                    <!-- {{pageDataDisplay}} dataFilteredForDisplay {{dataFilteredForDisplay.length}} supplementDataForDisplay {{supplementDataForDisplay.length}} totalResultDisplayed {{totalResultDisplayed}} 900 - 1275 one way single. 500-700 return per person-->
                                    <div class="d-flex align-items-start">

                                        <div class="" style="flex:1 1 0;">
                                            <div class="d-flex flex-column align-items-center displayinitials justify-content-center "><p class="p-0 m-0 h2 text-center ">{{each.first_name.charAt(0)}}{{each.last_name.charAt(0)}}</p></div>
                                        </div>

                                        <div class="ml-3 mr-3 ml-lg-5 mt-2 " style="flex:8 1 0;">
                                            <span class="percentagebaroutline" :style = "getColor(each.actual_pct,'border')"><span class="percentagebarfill" :style = "getColor(each.actual_pct,'bg')"></span></span>
                                            <p class="subtitle small mt-3">By {{each.first_name}} {{each.last_name}} on {{convertDate(each.date)}} - {{each.city}}, {{each.state}}</p>
                                            <p class="comments mt-5 text-center text-sm-left mb-5">“{{each.comments}}”</p>
                                        

                                            <div class="dividedRank1 clearfix text-center text-sm-left">
                                                <span class="ratingtitle">
                                                    <p class="small mt-1">{{each.ratings[0].name}}</p>
                                                </span>

                                                <span class = "d-inline-block ml-sm-3" >
                                                    <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                        <div v-if = "each.ratings[0].actual_score >= 1"  class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[0].actual_score >= 2"  class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[0].actual_score >= 3" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[0].actual_score >= 4" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[0].actual_score >= 5" class="reviewiconfilldark"></div>
                                                    </div>
                                                </span>
                                            </div>

                                            <div class="dividedRank2 clearfix text-center text-sm-left">
                                                <span class="ratingtitle">
                                                    <p class="small mt-1">{{each.ratings[1].name}}</p>
                                                </span>

                                                <span class = "d-inline-block ml-sm-3" >
                                                    <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                        <div v-if = "each.ratings[1].actual_score >= 1" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[1].actual_score >= 2" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[1].actual_score >= 3" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[1].actual_score >= 4" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[1].actual_score >= 5" class="reviewiconfilldark"></div>
                                                    </div>
                                                </span>
                                            </div>

                                            <div class="dividedRank3 clearfix text-center text-sm-left">
                                                <span class="ratingtitle">
                                                    <p class="small mt-1">{{each.ratings[2].name}}</p>
                                                </span>

                                                <span class = "d-inline-block ml-sm-3" >
                                                    <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                        <div v-if = "each.ratings[2].actual_score >= 1" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[2].actual_score >= 2" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[2].actual_score >= 3" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[2].actual_score >= 4" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[2].actual_score >= 5" class="reviewiconfilldark"></div>
                                                    </div>
                                                </span>
                                            </div>
                                                              
                                            <div class="dividedRank4 clearfix text-center text-sm-left">
                                                <span class="ratingtitle">
                                                    <p class="small mt-1">{{each.ratings[3].name}}</p>
                                                </span>

                                                <span class = "d-inline-block ml-sm-3" >
                                                    <div class="reviewiconborderdark mr-1 ml-sm-2">
                                                        <div v-if = "each.ratings[3].actual_score >= 1" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[3].actual_score >= 2" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[3].actual_score >= 3" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[3].actual_score >= 4" class="reviewiconfilldark"></div>
                                                    </div>
                                                    <div class="reviewiconborderdark mr-1">
                                                        <div v-if = "each.ratings[3].actual_score >= 5" class="reviewiconfilldark"></div>
                                                    </div>
                                                </span>
                                            </div>



                                        </div>
                                        
                                        <div class="perText" style="flex:0 0 0;">{{Math.floor(each.actual_pct*100)}}%</div>
                                    </div>

                    

                                </div>
                                <!-- End of Each Cell SupplementView-->
                                   

                        
                    </div>
                </div>
                </transition>

            
            <!-- End of Result cells -->


         

            <!-- Preloader to load more|| pageDataDisplay.e != 0 -->
            <div class="text-center" v-if = "pageDataDisplay.e != dataFilteredForDisplay.length">
                <pulse-loader :color= "{color:'#9a9c9f'}.color" :size= "{size:'10px'}.size"></pulse-loader>
            </div>




        <!-- <button v-if = "autoScrollContentLoader == true" class= "btn btn-primary btn-lg" @click = "incrementor">
            Incrementor
        </button> -->

        <!-- {{pageDataDisplay}} dataFilteredForDisplay {{dataFilteredForDisplay.length}} supplementDataForDisplay {{supplementDataForDisplay.length}} totalResultDisplayed {{totalResultDisplayed}} -->


    </div>
</template>


<script>
import moment from 'moment';
import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
import {apiURLBase} from './constants.js';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';



export default {

    name:'ResultList-With-Filter',
    props: ['storeSelected', 'reviewSelected'],
    components:{
        PulseLoader
    },
    data: function (){
       
        return {
            storeResultsRawData:{},
            dataFilteredForDisplay:{},
            supplementDataForDisplay:[],
            pageDataDisplay:{e:0,showPerPage:10},
            autoScrollContentLoader:false,
            showloader:false,
            showStarDropDown:true,
            loader: {color: '#515359', size:'40px'},
            filterActive:'Most Recent',
            localStoreSelected:{},
            showResultMainContent:false,
           
     }
    },
    computed: {
        totalResultDisplayed: function (){
            return this.dataFilteredForDisplay.length + this.supplementDataForDisplay.length;
        }

    },
    watch:{
        storeSelected : function(newVal, oldVal){
            this.showResultMainContent = false;
            this.$root.$emit('totalResultDisplayed', this.totalResultDisplayed, this.showResultMainContent);

            //TweenMax.to(".resultContent",0,{ opacity:0, y:20});
            // this.hideResultMainContent = true;
            this.getJSONforLid(this.storeSelected.loupeid);
        //{{moment(new Date(each.date*1000)).format('LLL')}}
        },
        dataFilteredForDisplay: function(newVal,oldVal){
            this.$root.$emit('totalResultDisplayed', this.totalResultDisplayed, this.showResultMainContent);
        },
         supplementDataForDisplay: function(newVal,oldVal){
             
            this.$root.$emit('totalResultDisplayed', this.totalResultDisplayed, this.showResultMainContent);
        },
        reviewSelected : function(newVal, oldVal){
            this.starFilterSelected(newVal);
        }



    },
    destroyed () {
        document.removeEventListener('click', this.documentClick)
    },

    created : function(){
          document.addEventListener('click', this.documentClick) 

           
            this.getJSONforLid(this.storeSelected.loupeid);

            const self = this;

              $(window).scroll(function() {
                if($(window).scrollTop() + $(window).height() > $(document).height() - 10) {
                        // console.log("scroll at end");
                        self.incrementor();
                    }
                });
            
            
    },
    methods : {
        
        beforeEnterELMainData: function (el) {
            el.style.opacity = 0;
        },
        enterELMainData(el,done){
            var jel = $(el);
            //console.log(el);
            TweenMax.to(el, 1, {opacity:1, ease:Power1.easeOut});
            TweenMax.from(jel.find(".displayinitials"), 1, { scale:0.5,  ease:Power4.easeOut});
            TweenMax.from(jel.find(".percentagebarfill"), 1, {width:0, ease:Power1.easeInOut});

            TweenMax.from(jel.find(".subtitle"), 1, {delay:0, x:"-=30",  opacity:0, ease:Power4.easeInOut});
            TweenMax.from(jel.find(".comments"), 1, {delay:0.5, x:"-=20",  opacity:0,  ease:Power4.easeOut});
       TweenMax.from(jel.find(".dividedRank1"), 1, {delay:0.65,  y:"+=20", opacity:0,  ease:Power4.easeOut});
       TweenMax.from(jel.find(".dividedRank2"), 1, {delay:0.75,  y:"+=20", opacity:0,  ease:Power4.easeOut});
       TweenMax.from(jel.find(".dividedRank3"), 1, {delay:0.85,  y:"+=20", opacity:0,  ease:Power4.easeOut});
       TweenMax.from(jel.find(".dividedRank4"), 1, {delay:0.95,  y:"+=20", opacity:0,  ease:Power4.easeOut});
            
            
            var vAll = jel.find(".perText");
            

            $.each(vAll, function( key, value ) {

                //console.log($(value).html());
                var v = $(value).html();
                var v1 = v.replace("%","");
                        
                var emptyObj = {countStart:0};
                
                TweenMax.to(emptyObj, 1, {countStart:v1, roundProps:"countStart", ease:Power1.easeOut, onUpdate:function(){
                    $(value).text(emptyObj.countStart+"%");
                }})

            });



             TweenMax.delayedCall(1.5, function (){
                done();
            })



        },
        enterEL(el,done){
          const self = this;


            var jel = $(el);
            // console.log(jel.children().length);
            TweenMax.from(jel, 0.5, {opacity:0, ease:Power1.easeOut});
            

             jel.children().each(function( index, item ) {
                // console.log($(item));
                TweenMax.from($(item).find(".percentagebarfill"), 1, {delay:index*0.2 ,width:0, ease:Power1.easeInOut});
            //    TweenMax.from($(item), 1, {delay:index*0.3 ,y:"+=45",opacity:0, ease:Power4.easeOut});
                TweenMax.from($(item).find(".displayinitials"), 1, {delay:index*0.1 ,scale:1.5,  ease:Power4.easeOut});

               var v = $(item).find(".perText").html();
               var v1 = v.replace("%","");
        
               var emptyObj = {countStart:0};
             

               TweenMax.to(emptyObj, 1, {delay:index*0.2, countStart:v1, roundProps:"countStart", ease:Power1.easeInOut, onUpdate:function(){
                   $(item).find(".perText").text(emptyObj.countStart+"%");
               }})


            });

            TweenMax.delayedCall(jel.children().length * 1, function (){
                done();
            })

            // done();
            //TweenMax.from(jel.find(".percentagebarfill"), 3, {opacity:0, onComplete:done});
            
            
        },
        leaveEL(el,done){
            // var jel = $(el);

            // TweenMax.to(jel, 1, {opacity:0, ease:Power1.easeOut, onComplete:done});
            done();
         },


        documentClick(e){
            
            var showStarDropDown = this.$refs.showStarDropDown;

            var target = e.target
            

            if(!showStarDropDown.contains(target)){
                if (!this.showStarDropDown) {
                 this.showStarDropDown = true;
                }
            }
 

        },
        
        getColor: function (pts, bgOrBorder){
            
            var col = "#54d76a";

            //1 star
            if (pts < 0.2){
                col = "#ff0000";
            }
            //2 star
            else if (pts >= 0.2 && pts < 0.4){
                col = "#ff8a00";
            }
            //3 star
            else if (pts >= 0.4 && pts < 0.6){
                col = "#ffe400";
            }
            //4 star
            else if (pts >= 0.6 && pts < 0.8){
                col = "#9fff17";
                }


            if (bgOrBorder == "bg"){
               
                return {
                        'background-color': col,
                        'width':Math.floor(pts*100) + '%',
                }
            }

            else if(bgOrBorder == "border"){

                 return {
                        'border-color':col,
                }


            }

        },
        
        convertDate: function (unixDate){

            return moment(unixDate*1000).format('MM/DD/YY');

        },
        getJSONforLid: function(lid){

            const self = this;
            
            var url = "https://s3.amazonaws.com/reviews.json." +apiURLBase+".com/store_" + lid + ".json?" + new Date().getTime();
            if (apiURLBase == "loupedev"){
                console.log("Make call for this store: ", this.storeSelected.name, url);
            }
           
            
                $.ajax({
                url: url,
                success: function(data)
                    {
                        self.storeResultsRawData = data;
                        self.filterStoreResultData(); 
                    },
                    error: function (error){
                        
                        console.log("Error", error);
                        
                        //TweenMax.to(".resultContent",0,{ opacity:1, y:0});
                    }
                });

            


                /*
                url = "./builds/store_"+lid+".json";
                $.getJSON(url)
                    .done( data =>  {

                    self.storeResultsRawData = data;
                    self.filterStoreResultData();
                }); //getJSON
                */


        },

        filterStoreResultData: function (){

            //Filter out the raw data with an active filter.
            const self = this;

            //Everytime a store changes or filter drop down changes we reset it back to 0.
            this.pageDataDisplay.e = 0;
            
            this.autoScrollContentLoaderUpdator();
            
            
            //Remove old supp data if the filter changes.
            this.supplementDataForDisplay = [];

            var filterData = this.storeResultsRawData.surveys.filter(

                function (el) {
                    if (self.filterActive == "5 Stars"){
                        return (el.actual_pct >= 0.8);
                    }
                    else if (self.filterActive == "4 Stars"){
                        return (el.actual_pct >= 0.6 && el.actual_pct < 0.8);
                    }
                    else if (self.filterActive == "3 Stars"){
                        return (el.actual_pct >= 0.4 && el.actual_pct < 0.6);
                    }
                    else if (self.filterActive == "2 Stars"){
                        return (el.actual_pct >= 0.2 && el.actual_pct < 0.4);
                    }
                    else if (self.filterActive == "1 Star"){
                        return (el.actual_pct < 0.2);
                    }
                    else if (self.filterActive == "Most Recent"){
                        return true;
                    }
                }

            );

            this.dataFilteredForDisplay = filterData;
            this.pageDataDisplay.e = (this.dataFilteredForDisplay.length < this.pageDataDisplay.showPerPage) ? this.dataFilteredForDisplay.length : this.pageDataDisplay.showPerPage;
            this.autoScrollContentLoaderUpdator();
            // TweenMax.to(".resultContent",0,{ opacity:0, y:20});
           

     

            //If the result after the filter is less than eqaul 3. load another call of the same filter (which has data from other markets).

            if (this.dataFilteredForDisplay.length <= 3){
                

                var apiName = "five_stars";
                if (self.filterActive == "5 Stars"){
                    apiName = "five_stars";
                }
                else if (self.filterActive == "4 Stars"){
                    apiName = "four_stars";
                }
                else if (self.filterActive == "3 Stars"){
                    apiName = "three_stars";
                }
                else if (self.filterActive == "2 Stars"){
                    apiName = "two_stars";
                }
                else if (self.filterActive == "1 Star"){
                    apiName = "one_star";
                }

                this.getJSONforActiveFilterFromOtherMarkets(apiName);
            }
            else{

                
                TweenMax.delayedCall(0.01, function(){
                            self.showResultMainContent = true;
                            self.$root.$emit('totalResultDisplayed', self.totalResultDisplayed, self.showResultMainContent);
                    });

            }
        

          


        },

        getJSONforActiveFilterFromOtherMarkets: function(filterApiName){

            const self = this;
            var url = "https://s3.amazonaws.com/reviews.json."+ apiURLBase + ".com/" + filterApiName + ".json?" + new Date().getTime();
            if (apiURLBase == "loupedev"){
                console.log("Loading another call because data is less on page1: ", url);
            }

            $.ajax({
                url: url,
                success: function(data)
                    {
                        //the 'supplementDataForDisplay' data and the 'dataFilteredForDisplay' data combined should not be more than 10 items.
                        
                        //Max 10 items combined.
                        var itemsToAddOnly = 10 - self.dataFilteredForDisplay.length;
                        
                        //Slice the items in the array.
                        var l = data.surveys;

                        self.supplementDataForDisplay = l.slice(0,itemsToAddOnly);

                        //TweenMax.to(".resultContent",1,{ opacity:1, y:0, ease: Back.easeOut.config(1.7)});
                         dCallToUpdateView();

                    },
                    error: function (error){
                        console.log("Error", error);
                        dCallToUpdateView();
                        //TweenMax.to(".resultContent",1,{ opacity:1, y:0, ease: Back.easeOut.config(1.7)});

                    }
                });

                function dCallToUpdateView(){
                   TweenMax.delayedCall(0.01, function(){
                            self.showResultMainContent = true;
                            self.$root.$emit('totalResultDisplayed', self.totalResultDisplayed, self.showResultMainContent);
                    });
                }

        },

        starFilterSelected: function (val){
               this.showResultMainContent = false;
               this.$root.$emit('totalResultDisplayed', this.totalResultDisplayed, this.showResultMainContent);

                this.showStarDropDown = true;
                this.filterActive = val;
               
                
                this.filterStoreResultData();

        },


        incrementor: function (){
            const r = ((Math.random() * 2) + 0.5); //0.0 - 2.5

            TweenMax.delayedCall(r, delayC);
            const self = this;

            function delayC(){
                var t = self.pageDataDisplay.e + self.pageDataDisplay.showPerPage;
                if (t > self.dataFilteredForDisplay.length){
                    t = self.dataFilteredForDisplay.length;
                }

                self.pageDataDisplay.e = t;
                self.autoScrollContentLoaderUpdator();
            }

        },

        autoScrollContentLoaderUpdator: function (){

            if (this.pageDataDisplay.e < this.dataFilteredForDisplay.length) {
                this.autoScrollContentLoader = true;
            }
            else{
                this.autoScrollContentLoader = false;
            }

            



        },
    }
}





</script>



<style>


.comments{
     font-size: 1.8rem;
}


.bounce-enter-active {
  animation: bounce-in .5s;
}
.bounce-leave-active {
  animation: bounce-in .5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}







.mesvg1{
  background-image: url("./assets/l_down_arrow.svg");
}

.reviewiconborderdark{
    border: 2px solid #43454b;
    border-radius: 50%;
	width: 20px;
    height: 20px; 
    display:inline-block;
}
.reviewiconfilldark{
    border-radius: 50%;
    margin:2px;
	width: 12px;
    height: 12px; 
    background-color: #43454b;
}


.dropdownfilter{
    position:absolute;
    left:-2px;
    top:51px;
    width:270px;
    padding:5px;
    border-radius: 25px;
    background-color: #cfd1d4;
    z-index:1;
}

.dropdownfilter a:hover{
    color: #13151b;
    text-decoration: none;
}

.jumbotron{
    border-radius: 25px;
    margin-bottom:40px;
    background-color: #f1f1f2;
    width:100%;
}
.percentagebaroutline{
    border: 1px solid #54d76a;
    height:13px;
    display:block;
    border-radius: 25px;

}
.percentagebarfill{
    background-color: #54d76a;
    height:11px;
    display:block;
    border-radius: 5px;
    width:80%;
}

.displayinitials{
    border: 2px solid black;
    border-radius: 50%;
	width: 50px;
    height: 50px; 
    display:inline-block;
}


.ratingtitle{

    float:left;

}


@media (max-width: 575px) {
    
    .ratingtitle{
        float:none;
        
    }


}

</style>





// WEBPACK FOOTER //
// ResultListWithFilter.vue?8453808a